<template>
  <add-clients-modal
    id="AddClients"
    expanded
    size="modal-lg"
    :show="show"
    @closed="close"
    @shown="onShown"
  >
    <div class="d-flex align-items-center mb-5">
      <base-heading class="add-clients__base-heading">
        <!-- Add Clients to {{ groupName }} -->
        Add to group
      </base-heading>
      <base-search
        class="search-bar"
        :value="search"
        @input="$emit('on-search', $event)"
      />
    </div>

    <div
      class="add-clients__list"
      @scroll="onScroll"
    >
      <base-list
        #default="{item}"
        :items="items"
        :loading="loading"
        mode="loadMore"
        @reload="$emit('reload')"
      >
        <group-client-cell
          v-model="selected"
          selectable
          hide-products
          hide-arrow
          :item="item"
          :value="item"
          @click="$event.select()"
        />
      </base-list>
    </div>

    <!--  FIXME  6/15/21 dlam:

        GroupDetailContainer dosent seem to be passing down

            :loading="nonMembersLoading"  (which is store.state.customers.isLoading)

        correctly (?)
    -->
    <template
      v-if="items.length > 0"
      #footer
    >
      <base-button
        text
        class="cancel-button"
        @click="close"
      >
        Cancel
      </base-button>
      <base-button
        primary
        class="add-button"
        :disabled="selected.length === 0"
        @click="addToGroup"
      >
        Save
        <!-- Add
        <span
          v-if="selected.length > 0"
          class="ml-1"
        >({{ selected.length }})</span> -->
      </base-button>
    </template>
  </add-clients-modal>
</template>

<script>

import GroupClientCell from '../ClientsList/GroupClientCell';
import AddClientsModal from './AddClientsModal';

export default {
  name: 'GroupCreate',
  components: {
    GroupClientCell,
    AddClientsModal,
  },
  props: {
    groupName: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      selected: [],
      search: '',
    };
  },
  methods: {
    close() {
      this.show = false;
      this.search = '';
      this.$emit('modal-closed');
    },
    open() {
      this.show = true;
    },
    onShown() {},
    createGroup() {
      this.show = false;
    },
    onSelect(added, item) {
      this.selected.push(item);
    },
    addToGroup() {
      this.$emit('add-to-group', this.selected);
      this.selected = [];
      this.close();
    },
    onScroll(evt) {
      if (evt.target.scrollTop + evt.target.clientHeight >= evt.target.scrollHeight) {
        // Bottom reached
        if (this.items.length <= this.count) {
          // Still elements to retrieve
          this.$emit('reached-bottom');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  margin-left: auto;
  min-width: 219px;
  height: 36px;

  &::v-deep input {
    font-size: 0.75rem;
  }
}
.add-clients{
  &__list {
    min-height: 50px;
    max-height: 50vh;
    overflow: auto;
  }
  &__base-heading{
    letter-spacing: -0.016px;
    font-weight: 600;
    margin-bottom: 0;
    font-family: $font-family-timepos-headline;
  }
}

.add-button {
  margin: 0;
  background: $dark-black;
  color: white;
  width: 160px;
  height: 40px;
  justify-content: center;
  font-family: $font-family-sans-serif-medium;
}
.cancel-button {
  font-family: $font-family-sans-serif-medium;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 5px 15px;
}
.client-cell-external{
  &_name{
    color: red;
  }
}
</style>
